"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterMenu = FooterMenu;
exports.FooterMenuContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _menu = _interopRequireDefault(require("../../navigation/other/menu"));
var _menuItem = _interopRequireDefault(require("../../navigation/other/menu/menu-item"));
const FooterMenuContainer = exports.FooterMenuContainer = /*#__PURE__*/(0, _react2.styled)("nav")({
  name: "FooterMenuContainer",
  class: "pl-f12ikn6t"
});

/**
 * Footer Menu component.
 *
 * @param {Object} props React props
 * @param {node} props.children Menu string
 * @returns {React.ReactElement} Footer Legal layout
 * @public
 */
function FooterMenu({
  id,
  menu
}) {
  const menuItems = menu?.menuItems;
  return /*#__PURE__*/_react.default.createElement(FooterMenuContainer, {
    id: `id-${id}`,
    "data-cy": "footer-menu"
  }, menuItems?.length && /*#__PURE__*/_react.default.createElement(_menu.default, {
    key: "menu"
  }, menuItems.map(({
    menuTitle,
    menuItems: items
  }, i) => /*#__PURE__*/_react.default.createElement(_menuItem.default, {
    key: i,
    tabIndex: "0"
  }, /*#__PURE__*/_react.default.createElement(_menu.default, {
    title: menuTitle
  }, items?.map(({
    title,
    ariaLabel,
    href
  }, j) => /*#__PURE__*/_react.default.createElement(_menuItem.default, {
    key: j,
    text: title,
    link: href,
    ariaLabel: ariaLabel
  })))))));
}
FooterMenu.propTypes = {
  id: _propTypes.default.string,
  menu: _propTypes.default.array
};